import React, { useEffect, useState } from 'react'
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import { SvgIcon } from '../../component/SvgIcon'
import { useSelector, useDispatch } from '../../store'
import { Package } from '../../store/package/reducer'
import { fetchPackage } from '../../store/package/actionCreator'
import { patchUserPackage } from '../../store/dashboard/actionCreator'

interface PackageMenuProps {
  subscriber: any
  setPackageTitle: (title: string) => void
}

export default function PackageMenuComponent(props: PackageMenuProps) {
  const [packageAnchorEl, setPackageAnchorEl] = useState<null | HTMLElement>(null)
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState<Record<string, HTMLElement | null>>({})

  const { packages } = useSelector((state) => state.package)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchPackage)
  }, [dispatch])

  const handlePackagePopper = (event: React.MouseEvent<HTMLElement>) => {
    setPackageAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setPackageAnchorEl(null)
    setSubMenuAnchorEl({})
  }

  const handleMoreOptionsClick = (event: React.MouseEvent<HTMLElement>, packageId: string) => {
    setSubMenuAnchorEl((prev) => ({ ...prev, [packageId]: event.currentTarget }))
  }

  function handleSelect(packageData: Package, isAnnual: boolean) {
    dispatch(patchUserPackage(props.subscriber.id, packageData.id, callback, isAnnual))
    handleClose()

    function callback() {
      props.setPackageTitle(packageData.title)
      if (props.subscriber.package) {
        props.subscriber.package.title = packageData.title
        props.subscriber.package.id = packageData.id
        props.subscriber.package.price = packageData.price as number
      }
    }
  }

  return (
    <>
      <Tooltip title={<span>Edit</span>}>
        <IconButton onClick={handlePackagePopper}>
          <SvgIcon name="edit" color="#000" size={{ width: 16, height: 14 }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={packageAnchorEl}
        open={Boolean(packageAnchorEl)}
        onClose={handleClose}
      >
        {packages?.map((el : any) => {
          const isTelegramUser = props.subscriber.uid.length === 36
          const isTelegramPackage = el.type === 'telegrambt'
          const isGeneral = el.type === 'general' || el.type === 'demo' || (el.type === 'personal' && el.uid === props.subscriber.uid)
          const isNotExistingPackage = el.id !== props.subscriber.package?.id
          const isAnnual = el?.isAnnual === true
          const isMonthly = el?.isAnnual === false

          const showSimpleItem =
            (isTelegramUser && isTelegramPackage && isMonthly) ||
            (!isTelegramUser && isGeneral && isNotExistingPackage && isMonthly)

          const showMenuWithOptions =
            (isTelegramUser && isTelegramPackage && isAnnual) ||
            (!isTelegramUser && isGeneral && isNotExistingPackage && isAnnual)

          if (showSimpleItem) {
            return (
              <MenuItem
                key={el.id}
                onClick={() => handleSelect(el, false)}
              >
                {el.title}
              </MenuItem>
            )
          }

          if (showMenuWithOptions) {
            const isSubMenuOpen = Boolean(subMenuAnchorEl[el.id])
            return (
              <React.Fragment key={el.id}>
                <MenuItem onClick={(e) => handleMoreOptionsClick(e, el.id)}>
                  {el.title} →
                </MenuItem>
                <Menu
                  anchorEl={subMenuAnchorEl[el.id]}
                  open={isSubMenuOpen}
                  onClose={() => setSubMenuAnchorEl((prev) => ({ ...prev, [el.id]: null }))}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <MenuItem onClick={() => handleSelect(el, false)}>{`${el.title} (Monthly, ${el.productId})`}</MenuItem>
                  <MenuItem onClick={() => handleSelect(el, true)}>{`${el.title} (Annual, ${el.annualProductId})`}</MenuItem>
                </Menu>
              </React.Fragment>
            )
          }

          return null
        })}
      </Menu>
    </>
  )
}
